module.exports = __webpack_public_path__ + "static/media/call-back.e27159d0.svg";